const inlineActionTestIds = {
  InlineActionItemWrapper: "inline-action-item-wrapper",
};

export default inlineActionTestIds;
